import React, { useState, useEffect, useref } from 'react';
import { Link } from 'react-router-dom';
import './styles.css'
import * as AiIcons from 'react-icons/ai';
import * as FcIcons from 'react-icons/fc';
import * as VscIcons from 'react-icons/vsc';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
import { Modal, Button } from "react-bootstrap";
import $, { data } from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const API_PATH = "cases";

function List(match) {
    const { path } = match;

    const [cases, setCases] = useState(null);
    const [all, setAll] = useState(null);
    const [active_cases, setActive] = useState(null);
    const [archived, setArchived] = useState(null);
    const [prospective, setProspective] = useState(null);

    const [mod, setMod] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [status, setStatus] = useState("All");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const radios = [
        { name: 'All', value: '1' },
        { name: 'Active', value: '2' },
        { name: 'Archived', value: '3' },
        { name: 'Prospective', value: '4' },
    ];

    const { register, watch, formState: { errors }, handleSubmit } = useForm();
    const [deleteId, setDeleteId] = useState(0);
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        console.log("close");
    };

    const confirmDelete = (id) => {
        setShow(true);
        setDeleteId(id);
    };

    function deleteCase() {
        console.log("deleting case id: " + deleteId);
        setCases(cases.map(x => {
            if (x.id === deleteId) { x.isDeleting = true; }
            return x;
        }));
        AxiosService.delete(API_PATH, deleteId).then(() => {
            setCases(cases => cases.filter(x => x.id !== deleteId));
        });
        setShow(false);
    };


    let history = useHistory();

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setMod(user.roles.includes("ROLE_MODERATOR"));
            setAdmin(user.roles.includes("ROLE_ADMIN"));
        }
        AxiosService.getAll(API_PATH).then(x => {

            /*for (var j in x.data) {
                var str_courts = "";
                var courts = x.data[j].courts
                x.data[j].case_name += x.data[j].case_id ? (", " + x.data[j].case_id) : "";
                for (var i in courts) {
                    str_courts += "(" + (courts[i].abbreviation) + ") "; //comma if there is more
                }
                x.data[j].case_name += str_courts ? (", " + str_courts) : str_courts;
            }*/

            setAll(x.data);

            var active_cases = x.data.filter(({ status }) => status === 'Active');
            setActive(active_cases);

            var archived_cases = x.data.filter(({ status }) => status === 'Archive');
            setArchived(archived_cases);

            var prospective_cases = x.data.filter(({ status }) => status === 'Prospective');
            setProspective(prospective_cases);

            setCases(active_cases);
            setStatus("Active");
        }
        );
    }, []);

    function filterDates(endDate) {
        setEndDate(endDate);
        //make this work by filters
        var filtered_cases = [];

        switch (status) {
            case "All":
                filtered_cases = all;
                break;
            case "Active":
                filtered_cases = active_cases;
                break;
            case "Archive":
                filtered_cases = archived;
                break
            case "Prospective":
                filtered_cases = prospective;
                break;
        }
        var ranges = filtered_cases.filter(lawsuit => lawsuit.deadline >= startDate.toISOString().slice(0, 10) && lawsuit.deadline <= endDate.toISOString().slice(0, 10))
        ranges.sort((a, b) => new Date(a.deadline) - new Date(b.deadline));
        setCases(ranges);
    }

    function search() {

        var keyword = watch("query").toLowerCase();
        var filtered_cases = [];

        switch (status) {
            case "All":
                filtered_cases = all;
                break;
            case "Active":
                filtered_cases = active_cases;
                break;
            case "Archive":
                filtered_cases = archived;
                break
            case "Prospective":
                filtered_cases = prospective;
                break;
        }

        var results = filtered_cases.filter(item => item.description.toLowerCase().includes(keyword) || item.next_steps.toLowerCase().includes(keyword) || item.case_name.toLowerCase().includes(keyword) || item.staff_member.toLowerCase().includes(keyword) || JSON.stringify(item.documents).toLowerCase().includes(keyword));
        setCases(results);
    }

    function sortCaseName() {
        var lawsuits = cases;
        lawsuits.sort((a, b) => a.case_name.localeCompare(b.case_name));
        setCases(cases.map(x => {
            return x;
        }));
    }

    function sortStaffMember() {
        var lawsuits = cases;
        lawsuits.sort((a, b) => a.staff_member.localeCompare(b.staff_member));
        setCases(cases.map(x => {
            return x;
        }));
    }

    function getAllCases() {
        setStatus("All");
        setCases(all);
    }

    function getActiveCases() {
        setStatus("Active");
        setCases(active_cases);
    }

    function getArchivedCases() {
        setStatus("Archive");
        setCases(archived);
    }

    function getProspectiveCases() {
        setStatus("Prospective");
        setCases(prospective);
    }
    $('button').on('click', function () {
        $('button').removeClass('active');
        $(this).addClass('active');
    });

    // $("btn-info").click(function(e){
    //    $("btn-info").removeClass("active");
    //    $(this).addClass("active");
    // });

    <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js"></script>

    return (

        <div>
            <h1 style={{ textAlign: 'center' }}>Cases</h1>
            <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" rel="stylesheet" />
            <script src="https://code.jquery.com/jquery-3.1.1.js"></script>
            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

            {(mod || admin) && (
                <Link to={`/cases/add`} className="btn btn-sm btn-success mb-2">Add Case</Link>
            )}
            {/** Search Functionality */}
            <form onSubmit={handleSubmit(search)} onReset={getAllCases}>
                <div className="form-row">
                    <div className="form-group col-5">
                        <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.query?.message}</div>
                    </div>
                    <div className="form-group col-5">
                        {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
                        <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
                    </div>
                </div>
            </form>
            <text>Results: {cases ? cases.length : 0}</text>
            <div class="btn-toolbar" role="toolbar" id="lettersToolbar" style={{ marginBottom: 5 }}>
                <div class="btn-group mr-2">

                    <button onClick={getAllCases} style={{ marginRight: 8 }} class="btn btn-info" id="ALL">ALL</button>
                    <button checked={true} onClick={getActiveCases} style={{ marginRight: 8 }} class="btn btn-info active" id="D">Active</button>
                    <button onClick={getArchivedCases} style={{ marginRight: 8 }} class="btn btn-info" id="M">Archived</button>
                    <button onClick={getProspectiveCases} style={{ marginRight: 8 }} class=" btn btn-info" id="S">Prospective</button>
                    <DatePicker
                        className={`form-control ${errors.query ? 'is-invalid' : ''}`}
                        dateFormat="MM-dd-yyyy"
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        onChange={date => setStartDate(date)}
                    />
                    <DatePicker
                        className={`form-control ${errors.query ? 'is-invalid' : ''}`}
                        dateFormat="MM-dd-yyyy"
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        onChange={date => filterDates(date)/*setEndDate(date)*/}
                    />
                </div>
            </div>
            <table className="table table-bordered table-hover table-hover-cursor">
                <thead>
                    <tr >

                        <th onClick={sortCaseName} style={{ width: '10%', cursor: "pointer" }}>Case Name</th>
                        <th onClick={sortStaffMember} style={{ width: '12%', cursor: "pointer" }}>Attorney</th>
                        <th style={{ width: '40%' }}>Description</th>
                        <th style={{ width: '40%' }}>Status / Next Steps</th>
                        <th style={{ width: '10%' }}>Lawsuit Details</th>
                    </tr>
                </thead>
                <tbody class="searchable">
                    {cases && cases.map(case_ =>
                        <tr key={case_.id}>
                            <td>{case_.case_name}</td>
                            <td>{case_.staff_member}</td>
                            <td> <td style={{ whiteSpace: 'pre-line' }} className='desc'>{case_.description}</td>
                            </td>
                            <td> <td style={{ whiteSpace: 'pre-line' }} className='truncate'>{case_.next_steps}</td>
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>


                                <Link to={`/cases/view/${case_.id}`} className="btn btn-sm btn-info mr-2"> <VscIcons.VscOpenPreview size={22} /> </Link>
                                {(mod || admin) && (
                                    <Link to={`/cases/edit/${case_.id}`} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
                                )}


                                {admin && (
                                    <button
                                        className="btn btn-sm btn-danger mr-2"
                                        onClick={() => confirmDelete(case_.id)}
                                    >
                                        <AiIcons.AiFillDelete size={22} />
                                    </button>

                                )}


                            </td>

                        </tr>

                    )}
                    {!cases &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {cases && !cases.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No Cases To Display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete?</Modal.Title>
                </Modal.Header>
                <Modal.Body>Would you like to delete this firm?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => deleteCase(cases.id)}>
                        OK
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <script>
         $(document).ready(function(){
            $("#demo").on("keyup", function() {
               var value = $(this).val().toLowerCase();
               $("#test tr").filter(function() {
                  $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
               });
            })
         });
      </script> */}
        </div >



    );
}

export { List };